import { Modal, Stack } from 'react-bootstrap';

import CheckmateSelect from '../../components/shared/CheckmateSelect';
import { IQueryFilterCriteria } from '../../interfaces/IQuery';
import { IValidation } from '../../interfaces/IError';

interface IQueryExportModalProps {
    availableColumnsForExport: IQueryFilterCriteria[];
    open: boolean;
    onExportColumnsChange: (optionsList: any) => void;
    onHide: () => void;
    onSubmit: () => void;
    selectedColumns: IQueryFilterCriteria[];
    validation: IValidation;
}

export function QueryExportModal(props: IQueryExportModalProps) {
    return (
        <Modal centered show={props.open} backdrop>
            <Modal.Header>
                <Modal.Title>Export</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.validation.export && (
                    <div className="text-danger mb-3">{props.validation.export}</div>
                )}
                <div className="row mb-2">
                    <>
                        <CheckmateSelect
                            isMulti={true}
                            options={props.availableColumnsForExport}
                            value={props.selectedColumns}
                            onChange={props.onExportColumnsChange}
                        />
                    </>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Stack
                    direction="horizontal"
                    style={{ justifyContent: 'space-between', width: '100%' }}
                >
                    <label>
                        <input id="chkSave" className="form-check-input" type="checkbox" />
                        <span>&nbsp;&nbsp;Save Query Export</span>
                    </label>
                    <div>
                        <button className="btn btn-default" onClick={props.onHide}>
                            Cancel
                        </button>
                        <button className="btn btn-orange" onClick={props.onSubmit}>
                            Run
                        </button>
                    </div>
                </Stack>
            </Modal.Footer>
        </Modal>
    );
}
